import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ApiUrl from "../../config/app-config";

const baseURL = ApiUrl();

const NoticeDetail = (props) => {
  /*header 영역*/
  /* api 받아오는 부분 */
  const [data, setData] = useState();
  const contentId = useParams();
  async function getData() {
    props.onIsLoading(true);
    try {
      //응답 성공
      const response = await axios.get(`${baseURL}/v1/notice`, {
        params: {
          id: contentId.id,
        },
      });
      const success = response.data;
      const result = success.result;
      props.onIsLoading(false);
      console.log(result[0]);
      setData(result[0]);
    } catch (error) {
      //응답 실패
      props.onIsLoading(false);
      props.onError(true);
      console.error(error);
    }
  }
  useEffect(() => {
    if (!data) {
      getData();
    }
  }, []);
  const pageName = "공지사항 상세";
  const headerUi = {
    goback: false,
    closeAll: true,
  };
  useEffect(() => {
    props.onPageName(pageName);
  }, []);
  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);
  // const faqDetailData =
  //   data && data.filter((item) => String(item.id) === String(contentId.id));
  // const faqData = faqDetailData[0];
  // console.log(faqDetailData[0])

  return (
    <>
      {data ? (
        <div className="container faq_detail_wrap">
          <h3>{data.title}</h3>
          <p className="font-content">{data.content}</p>
        </div>
      ) : (
        <div>
          <h5>존재하지 않거나</h5>
          <h5>삭제된 공지입니다.</h5>
        </div>
      )}
    </>
  );
};
export default NoticeDetail;
